import { FileText, Package, Receipt } from "lucide-react";
import { ReassignMenu } from "@/components/operators/ReassignMenu";

const ICONS = { FileText, Package, Receipt };

export function MatrixChip({
  ev, operatorId, isoDate, chipIndex,
  isDragging, draggable, onDragStart, onDragEnd, onClick,
  showReassign, operators, onReassigned,
}) {
  const Icon = ICONS[ev.icon];
  return (
    <div
      draggable={draggable}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      className={`flex items-stretch gap-1 group ${isDragging ? "opacity-40" : ""}`}
    >
      <button
        onClick={onClick}
        data-testid={`matrix-chip-${operatorId}-${isoDate}-${chipIndex}`}
        title={`${ev.type}: ${ev.number}${ev.customer ? " — " + ev.customer : ""} (trascina per spostare)`}
        className="flex-1 min-w-0 flex items-center gap-1 px-1 py-0.5 rounded-sm bg-white border border-zinc-200 hover:bg-zinc-50 transition text-left text-[10px] cursor-grab active:cursor-grabbing"
        style={{ borderLeftWidth: 3, borderLeftColor: ev.color }}
      >
        {Icon && <Icon className="w-3 h-3 shrink-0" style={{ color: ev.color }} />}
        <span className="font-mono truncate text-[9px]">{ev.number}</span>
        {ev.isStorage && (
          <span className="shrink-0 text-[8px] uppercase tracking-wider px-0.5 rounded-sm bg-amber-100 text-amber-700">D</span>
        )}
      </button>
      {showReassign && (
        <ReassignMenu
          docId={ev.doc_id}
          docType={ev.doc_type}
          currentOperatorId={operatorId}
          operators={operators}
          onReassigned={onReassigned}
        />
      )}
    </div>
  );
}
